import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "common/css/master.css";
import "../css/subjectAllocation.css";
import Loader from "common/components/Loader";
import Header from "common/js/header/header";


import { getSubjectAllocationListSvc, saveSubjectSharedSlotSvc, deleteSubjectSharedSlotSvc } from "./subjectAllocationSvc.js";
import SubjectTeacherAllocationCtrl from "./subjectTeacherAllocationWeeklyCtrl.js";
import SubjectAllocationHeader from "./subjectAllocationHeader.js";

const SubjectAllocationWeeklyCtrl = () => {
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [lstSubjectAllocation, setLstSubjectAllocation] = useState([]);
    const [syllabusId, setSyllabusId] = useState(0); // New state for syllabus
    const [lstSubId, setLstSubId] = useState([]);
    const [key, setKey] = useState(0);
    const [filters, setFilters] = useState({ sub: null, sharedSlotNo: null, showOnlyBlockPeriods: false })
    useEffect(() => {
        // console.log("SubjectAllocationCtls called");
        if (!!syllabusId)
            getSubjectAllocationList(syllabusId);
    }, [syllabusId, key]);

    const resetFilters = ()=>{
        setFilters({ sub: null, sharedSlotNo: null, showOnlyBlockPeriods: false })
    }

    const updateKey = () => {
        setKey(prevKey => prevKey + 1);
    };


    const getSubjectAllocationList = async (pSyllabusId) => {
        // console.log("getSubjectAllocationList called");
        await setLstSubjectAllocation([]);
        setLoader("block");
        setOpacity(0.5);
        getSubjectAllocationListSvc(pSyllabusId, subjectAllocationListResponse);
    };

    const subjectAllocationListResponse = (data) => {
        // console.log("subjectAllocationListResponse called, data", data);
        if (data.status === "Success") {
            setLstSubId([]);
            setLstSubjectAllocation(data.lstSubject);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    };

    const handleSelectChange = (pSubId) => {
        // console.log("handleSelectChange called, subjectId", pSubId);

        // Update the state based on whether pSubId exists in lstSubId or not
        const updatedLstSub = lstSubId.includes(pSubId)
            ? lstSubId.filter((id) => id !== pSubId) // Remove pSubId if it exists
            : [...lstSubId, pSubId]; // Add pSubId if it doesn't exist

        setLstSubId(updatedLstSub); // Update the state
    };

    const saveSubjectSharedSlot = () => {
        if (!lstSubId || lstSubId.length < 2) {
            toast.warn("Please select atleast 2 subjects ");
            return;
        }
        const sharedSlotObj = {
            syllabusId,
            lstSubId
        };
        // console.log("sharedSlotObj", sharedSlotObj);
        setLoader("block");
        setOpacity(0.5);
        saveSubjectSharedSlotSvc(sharedSlotObj, saveSubjectSharedSlotResponse);
    };

    const saveSubjectSharedSlotResponse = async (data) => {
        // console.log("saveSubjectSharedSlotResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            await updateKey();
        } else if (data.status === "Failure") {
            toast.error(data.message);
        } else {
            toast.error("Service failed: " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    };

    const checkDeleteSlotElegibility = () => {
        // console.log("checkDeleteSlotElegibility called");
        // console.log("lstSubId", lstSubId, ", lstSubjectAllocation", lstSubjectAllocation);

        const isSingleSubjectLeft = (pSubId) => {
            let currentSlotNo = lstSubjectAllocation.find((sub) => sub.subId === pSubId).sharedSlotNo;
            let currentSlotSubs = lstSubjectAllocation
                .filter((sub) => sub.sharedSlotNo === currentSlotNo)
                .map((sub) => sub.subId);
            // console.log("currentSlotSubs", currentSlotSubs);
            // console.log("currentSlotNo", currentSlotNo);
            let difference = currentSlotSubs.filter((subId) => !lstSubId.includes(subId));
            if (difference.length === 1) {
                // console.log("There is exactly one item in currentSlotSubs that is not in lstSubId:", difference[0]);
                return true;
            }
            return false;
        }

        for (let i = 0; i < lstSubId.length; i++) {
            // console.log("lstSubId[", i, "] ", lstSubId[i]);
            if (isSingleSubjectLeft(lstSubId[i]))
                return false;
        }
        return true;
    }

    const deleteSharedSlot = () => {
        // console.log("deleteSharedSlots called");
        if (!lstSubId || lstSubId.length < 1) {
            toast.warn("Please select atleast 1 subject ");
            return;
        }
        if (!checkDeleteSlotElegibility()) {
            toast.warn("You can't left only one slot from shared slots unselected ");
            return;
        }
        const deleteSlotObj = {
            syllabusId,
            lstSubId
        };
        // alert("delete slot service to be called");
        // console.log("deleteSlotObj", deleteSlotObj);
        setLoader("block");
        setOpacity(0.5);
        deleteSubjectSharedSlotSvc(deleteSlotObj, deleteSubjectSharedSlotResponse);
    }


    const deleteSubjectSharedSlotResponse = async (data) => {
        // console.log("deleteSubjectSharedSlotResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            await updateKey();
        } else if (data.status === "Failure") {
            toast.error(data.message);
        } else {
            toast.error("Service failed: " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    };


    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const setSyllabusDataFilters = (pId)=>{
        setSyllabusId(pId)
        resetFilters()
    }

    return (
        <div>
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div
                className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: loader === "none" ? 'pointer' : 'none',
                    pointerEvents: loader === "none" ? 'auto' : 'none',
                    opacity: opacity
                }}
            >
                <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-centered padding-remove" style={{ marginTop: "15px" }}>
                    <SubjectAllocationHeader
                        setFilters={setFilters}
                        setLoader={setLoader}
                        setOpacity={setOpacity}
                        syllabusId={syllabusId}
                        setSyllabusId={setSyllabusDataFilters}
                        lstSubId={lstSubId}
                        handleSelectChange={handleSelectChange}
                        saveSubjectSharedSlot={saveSubjectSharedSlot}
                        deleteSharedSlot={deleteSharedSlot}
                        updateKey={updateKey}
                    />
                </div>
                <SubjectTeacherAllocationCtrl
                    key={syllabusId}
                    filters={filters}
                    setFilters={setFilters}
                    loader={loader}
                    setLoader={setLoader}
                    opacity={opacity}
                    setOpacity={setOpacity}
                    lstSubjectAllocation={lstSubjectAllocation}
                    setLstSubjectAllocation={setLstSubjectAllocation}
                    syllabusId={syllabusId}
                    lstSubId={lstSubId}
                    handleSelectChange={handleSelectChange}
                    updateKey={updateKey}
                />
            </div>
        </div>
    );
};

export default SubjectAllocationWeeklyCtrl;
